.container {
  display: grid;
  gap: 16px;
}

.container-1 {
  grid-template-columns: repeat(1, 1fr);
}

.container-2 {
  grid-template-columns: repeat(2, 1fr);
}

.container-3 {
  grid-template-columns: repeat(3, 1fr);
}

@media (max-width: 600px) {
  .container-2,
  .container-3 {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media print {
  .container-2,
  .container-3 {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
